import { createFileRoute, redirect } from '@tanstack/react-router'
import { useDeeplinks } from '../../../../../route'

export const Route = createFileRoute(
  '/app/deeplinks/programs/$programId/sets/$setId/modules/$moduleId',
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { setId, moduleId } = Route.useParams()
  const { defaultOrg } = useDeeplinks()
  throw redirect({
    to: `/app/organizations/${defaultOrg.id}/sets/${setId}/modules/${moduleId}`,
  })
}
